import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e12ed38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-container" }
const _hoisted_2 = { class: "row-fields-3-1" }
const _hoisted_3 = { class: "row-fields-2-3-1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-1-explainer" }, " Optionally charge each Landlord for producing their Summary Statement: ", -1))
const _hoisted_5 = { class: "row-fields-1-2" }
const _hoisted_6 = { class: "field-container" }
const _hoisted_7 = { class: "tab-container" }

import { computed, onMounted, ref, watch } from "vue";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import GroupFieldsetComponent from "@/components/accounts/group-fieldset-component.vue";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import DateRangesInput from "@/components/ui/inputs/date-ranges-input.vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import { CodeType } from "acquaint-api/constants/CodeType";
import {
  ContactType,
  PreferredDeliveryMethod,
} from "@/enums/financials/ContactType";
import ContactLookup from "@/components/ui/lookup/contact-lookup.vue";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import { useFinancialHelper } from "@/utils/financials/useFinancialHelper";
import {
  SummaryStatementFormItem,
  SummaryStatementItem,
} from "@/types/financials/SummaryStatement";
import CurrencyInput from "@/components/ui/inputs/currency-input.vue";
import AcquaintTextArea from "@/components/ui/inputs/acquaint-text-area.vue";
import { TransactionsValidation } from "acquaint-api/validation/TransactionsValidation";
import SummaryStatementGrid from "@/components/financials/summary-statement-grid.vue";
import moment from "moment";
import { BankAccountType } from "@/enums/accounts/AccountEnums";
import { useContactHelper } from "@/utils/contacts/useContactHelper";
import { DateRanges } from "@/enums/DateRanges";
import {
  DeleteFeeRequest,
  OneOffFeeRequest,
} from "@/types/financials/OneOffFeeRequest";
import { AccountItem } from "@/types/financials/AccountItem";
import { displayQuestionAlert } from "@/alerts/questionAlert";
import { FinancialDefaults } from "@/utils/financials/FinancialDefaults";
import { sleep } from "@/utils/system/TimeoutHelper";
import SummaryStatementStep2 from "@/components/financials/summary-statement-step2.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'summary-statements-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const contactHelper = useContactHelper();
const financialHelper = useFinancialHelper();
const summaryStatementsList = ref<SummaryStatementItem[]>([]);
const summaryStatementsPostingList = ref<SummaryStatementItem[]>([]);
const summaryStatementsEmailList = ref<SummaryStatementItem[]>([]);
const defaultDateRange = ref<DateRanges>(DateRanges.CustomRange);
const formItem = ref<SummaryStatementFormItem>(
  FinancialDefaults.defaultSummaryStatementFormItem(),
);

const modalKey = ref(0);
const selectedTab = ref(0);
const loading = ref(false);
const mbooStatementsProduced = ref(false);

const statmentCount = computed(() => {
  return summaryStatementsList.value.reduce((count, item) => {
    return item.include ? count + 1 : count;
  }, 0);
});

const loadDataIntoGrid = async () => {
  loading.value = true;
  await sleep(300);
  const items = await financialHelper.getSummaryStatements({
    contactType: formItem.value.contactType,
    contactId: formItem.value.specialContactId,
    bankAccountId: formItem.value.bankAccountId,
    startDate: formItem.value.startDate,
    endDate: formItem.value.endDate,
  });

  if (items) {
    summaryStatementsList.value = items.map((item, index) => ({
      ...item,
      id: index,
    }));
  }
  loading.value = false;
};

const calculateTaxYear = () => {
  const currentYear = moment().year();

  const start = moment(`01/04/${currentYear - 1}`, "DD/MM/YYYY");
  const end = start.clone().add(1, "year").subtract(1, "days");

  formItem.value.startDate = start.format("YYYY-MM-DD");
  formItem.value.endDate = end.format("YYYY-MM-DD");
};

watch([() => showModal.value], async ([newModal]) => {
  if (!newModal) {
    return;
  }

  modalKey.value++;
  formItem.value = FinancialDefaults.defaultSummaryStatementFormItem();
  selectedTab.value = 0;
  formItem.value.contactType = ContactType.Landlord;
  formItem.value.bankAccountId = BankAccountType.Client;

  defaultDateRange.value = DateRanges.CustomRange;
  calculateTaxYear();

  await loadDataIntoGrid();
});

watch(
  () => statmentCount.value,
  () => {
    if (statmentCount.value > 0) {
      formItem.value.enableButRun = true;
    } else {
      formItem.value.enableButRun = false;
    }
  },
);

const booEnabled = computed(() => {
  return formItem.value.productId > 0;
});

const onDateRangeOptionChanged = async () => {
  loadDataIntoGrid();
};

const onSpecialContactChange = async () => {
  await loadDataIntoGrid();
};

const onBankAccountChange = async () => {
  await loadDataIntoGrid();
};

const onContactTypeChange = async () => {
  await loadDataIntoGrid();
};

const process = async () => {
  if (includedItems.value.length === 0) return;

  mbooStatementsProduced.value = true;

  // Optionally charge fee - but charge two amounts if they have already done it today!
  if (formItem.value.productId > 0 && formItem.value.debitAmount > 0) {
    const request: OneOffFeeRequest = {
      productId: formItem.value.productId,
      amount: formItem.value.debitAmount,
      statementNotes: formItem.value.statementNotes,
      accounts: accountItems.value,
    };
    await financialHelper.createOneOffFee(request);
  }

  formItem.value.enableButRun = false;
  formItem.value.enableButPrintForFiling = true;
  formItem.value.enableButPrintForPosting = true;
  formItem.value.enableButEmail = true;
  formItem.value.enableGrpCharge = false;
  formItem.value.enableGrpContacts = false;

  updateStep2Counts();
};

const includedItems = computed(() => {
  return summaryStatementsList.value.filter((item) => item.include);
});

const accountItems = computed<AccountItem[]>(() => {
  return includedItems.value.map((item) => ({
    contactId: item.contactId,
    propertyId: item.propertyId,
  }));
});

const contactIds = computed<number[]>(() => {
  return summaryStatementsEmailList.value.map((item) => item.contactId);
});

const propertyIds = computed<number[]>(() => {
  return summaryStatementsEmailList.value.map((item) => item.propertyId);
});

const updateStep2Counts = async () => {
  let intEmailCount = 0;
  let intPostCount = 0;
  summaryStatementsEmailList.value = [];
  summaryStatementsPostingList.value = [];

  for (const item of includedItems.value) {
    const contactItem = await contactHelper.fetchContactById(item.contactId);

    if (contactItem) {
      const hasEmail = contactItem.email && contactItem.email !== "";
      const method = contactItem.preferredDeliveryMethod;

      if (hasEmail) {
        if (
          method === PreferredDeliveryMethod.Email ||
          method === PreferredDeliveryMethod.EmailPrint
        ) {
          intEmailCount++;
          summaryStatementsEmailList.value = [
            ...summaryStatementsEmailList.value,
            item,
          ];
        }
        if (
          method === PreferredDeliveryMethod.Print ||
          method === PreferredDeliveryMethod.EmailPrint
        ) {
          intPostCount++;
          summaryStatementsPostingList.value = [
            ...summaryStatementsPostingList.value,
            item,
          ];
        }
      } else {
        // No email so post only
        intPostCount++;
      }
    }
  }

  formItem.value.statementsFilings = statmentCount.value;
  formItem.value.statementsPostings = intPostCount;
  formItem.value.statementsEmails = intEmailCount;

  if (intPostCount > 0) {
    formItem.value.enableButPrintForPosting = true;
  } else {
    formItem.value.enableButPrintForPosting = false;
  }

  if (intEmailCount > 0) {
    formItem.value.enableButEmail = true;
  } else {
    formItem.value.enableButEmail = false;
  }

  selectedTab.value = 1;
};

const onRunClick = async () => {
  await process();
};

const onExitClick = async () => {
  if (mbooStatementsProduced.value) {
    if (formItem.value.productId > 0 && formItem.value.debitAmount > 0) {
      const question = await displayQuestionAlert(
        'Were your Statements correct and have they been successfully produced? If you say "NO" then the Charge you made to each Contact will be removed.',
      );

      if (!question.isConfirmed) {
        const request: DeleteFeeRequest = {
          productId: formItem.value.productId,
          amount: formItem.value.debitAmount,
          accounts: accountItems.value,
        };
        await financialHelper.deleteTransactionBatch(request);
      }
    }
  }
  showModal.value = false;
};

const modalClosed = () => {
  showModal.value = false;
};

const onSummaryStatementsListChange = (newItems: SummaryStatementItem[]) => {
  summaryStatementsList.value = [...newItems];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showModal).value = $event)),
    title: "Summary Statements",
    key: modalKey.value,
    height: '780',
    width: _unref(ModalWidth).Medium,
    onModalClosed: modalClosed
  }, {
    content: _withCtx(() => [
      _createVNode(_unref(DxTabPanel), {
        "scroll-by-content": true,
        "show-nav-buttons": true,
        "swipe-enabled": false,
        selectedIndex: selectedTab.value,
        "onUpdate:selectedIndex": _cache[8] || (_cache[8] = ($event: any) => ((selectedTab).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxItem), { title: "Step 1" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(GroupFieldsetComponent, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          (_openBlock(), _createBlock(DateRangesInput, {
                            key: modalKey.value,
                            title: "Date Range",
                            "start-date": formItem.value.startDate,
                            "onUpdate:startDate": _cache[0] || (_cache[0] = ($event: any) => ((formItem.value.startDate) = $event)),
                            "end-date": formItem.value.endDate,
                            "onUpdate:endDate": _cache[1] || (_cache[1] = ($event: any) => ((formItem.value.endDate) = $event)),
                            fromAccounts: false,
                            "read-only": !formItem.value.enableGrpContacts,
                            defaultRange: defaultDateRange.value,
                            onDateRangeOptionChanged: onDateRangeOptionChanged
                          }, null, 8, ["start-date", "end-date", "read-only", "defaultRange"]))
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(LookupSingleSelect, {
                          label: "Account",
                          modelValue: formItem.value.bankAccountId,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((formItem.value.bankAccountId) = $event)),
                            onBankAccountChange
                          ],
                          "read-only": !formItem.value.enableGrpContacts,
                          "lookup-source": _unref(LookupTableSource).BankAccounts
                        }, null, 8, ["modelValue", "read-only", "lookup-source"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(SystemCodeSingleSelect, {
                        label: "Contact Type",
                        "code-type": _unref(CodeType).ContactType,
                        modelValue: formItem.value.contactType,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((formItem.value.contactType) = $event)),
                          onContactTypeChange
                        ],
                        "read-only": !formItem.value.enableGrpContacts
                      }, null, 8, ["code-type", "modelValue", "read-only"]),
                      _createElementVNode("div", null, [
                        _createVNode(ContactLookup, {
                          modelValue: formItem.value.specialContactId,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((formItem.value.specialContactId) = $event)),
                            onSpecialContactChange
                          ],
                          label: "Specific Contact",
                          "read-only": !formItem.value.enableGrpContacts,
                          showClearIcon: true
                        }, null, 8, ["modelValue", "read-only"])
                      ]),
                      _createVNode(AcquaintInfoBox, {
                        label: "Statement Count",
                        text: statmentCount.value.toString()
                      }, null, 8, ["text"])
                    ]),
                    _createVNode(SummaryStatementGrid, {
                      "read-only": !formItem.value.enableGrpContacts,
                      loading: loading.value,
                      "summary-statements-list": summaryStatementsList.value,
                      "onUpdate:summaryStatementsList": onSummaryStatementsListChange
                    }, null, 8, ["read-only", "loading", "summary-statements-list"])
                  ]),
                  _: 1
                }),
                _createVNode(GroupFieldsetComponent, null, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(LookupSingleSelect, {
                          label: "Product",
                          modelValue: formItem.value.productId,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formItem.value.productId) = $event)),
                          lookupSource: _unref(LookupTableSource).Products,
                          showSearch: true,
                          showClearButton: true,
                          readOnly: !formItem.value.enableGrpCharge
                        }, null, 8, ["modelValue", "lookupSource", "readOnly"]),
                        _createVNode(CurrencyInput, {
                          modelValue: formItem.value.debitAmount,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formItem.value.debitAmount) = $event)),
                          label: "Debit Amount (inc VAT)",
                          readOnly: !booEnabled.value || !formItem.value.enableGrpCharge
                        }, null, 8, ["modelValue", "readOnly"])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _createVNode(AcquaintTextArea, {
                            fieldValidation: _unref(TransactionsValidation).StatementNotes,
                            label: "Statement Notes",
                            modelValue: formItem.value.statementNotes,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formItem.value.statementNotes) = $event)),
                            height: '5.5rem',
                            "read-only": !booEnabled.value || !formItem.value.enableGrpCharge
                          }, null, 8, ["fieldValidation", "modelValue", "read-only"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(DxItem), { title: "Step 2" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(SummaryStatementStep2, {
                  "account-items": accountItems.value,
                  "form-item": formItem.value,
                  "contact-ids": contactIds.value,
                  "property-ids": propertyIds.value
                }, null, 8, ["account-items", "form-item", "contact-ids", "property-ids"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selectedIndex"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          disabled: !formItem.value.enableButRun,
          text: 'Run',
          onClick: () => {
            onRunClick();
          },
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Exit',
          onClick: () => {
            onExitClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})